import { config } from '../config'
import firebase from 'firebase'
import "firebase/firestore"

  firebase.initializeApp(config.firebase)
  const db = firebase.firestore();
  const settings = {timestampsInSnapshots: true};
  db.settings(settings);

  export { db }
  export const firebaseAuth = firebase.auth
  


// WEBPACK FOOTER //
// ./src/firebase/index.js